module.exports = __webpack_public_path__ + "assets/img/1701_06.jpg?9e1be1807e5255753a152efb24b7d80c";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1701_06.jpg
// module id = 1125
// module chunks = 0